import onSendUtilizationData from './onSendUtilizationData';

export default { onSendUtilizationData };
